
import * as THREE from 'three';
import { OBB } from 'three/examples/jsm/math/OBB.js';
import { ThreeView } from './View3dWebCad';

export class BBOXManager {

    private line: THREE.LineSegments;

    constructor(name: string, color: THREE.Color) {
        this.create(name, color);
    }

    private create(_name: string, _color: THREE.Color) {
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const edgeGeometry = new THREE.EdgesGeometry(geometry);
        this.line = new THREE.LineSegments(edgeGeometry, new THREE.LineBasicMaterial({
            color: _color, toneMapped: false
        }));
        this.line.name = _name;
        ThreeView.get().wcItemmgr.addOtherShapes(this.line);
        this.line.visible = false;
    }

    public reSize(object: THREE.Object3D) {
        const position = new THREE.Vector3();
        const quaternion = new THREE.Quaternion();
        const scale = new THREE.Vector3();
        // ワールド座標での値を取得
        object.matrixWorld.decompose(position, quaternion, scale);

        const box = new THREE.Box3().setFromObject(object);
        this.line.position.copy(box.getCenter(new THREE.Vector3()));
        this.line.quaternion.copy(quaternion);
        if (!object.userData.obb) return;
        const obb = (<OBB>object.userData.obb.obb);
        const scale_ = obb.halfSize.clone().multiplyScalar(2).multiply(scale);
        this.line.scale.copy(scale_.multiplyScalar(1.01));
    }

    public showBox() {
        if (!this.line) return;
        this.line.visible = true;
    }

    public hideBox() {
        if (!this.line) return;
        this.line.visible = false;
    }

    public remove() {
        ThreeView.get().wcItemmgr.removeOtherShapes(this.line);
    }

}
